import { isValid } from "date-fns";
import { useGetOne, useTranslate } from "ra-core";

import type { Deal, Sale } from "../types";

/**
 * Shows "Last changed by <name>, <date time>" for an enquiry.
 * Renders nothing when no user is recorded (system writes) or the user
 * cannot be resolved, so a broken or empty name is never displayed.
 */
export const DealLastChanged = ({ deal }: { deal: Deal }) => {
  const translate = useTranslate();
  const { data: sale } = useGetOne<Sale>(
    "sales",
    { id: deal.updated_by ?? undefined },
    { enabled: deal.updated_by != null },
  );

  const name = sale ? `${sale.first_name} ${sale.last_name}`.trim() : "";
  if (!name || !isValid(new Date(deal.updated_at))) return null;

  const date = new Date(deal.updated_at).toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  return (
    <p
      className="text-xs text-muted-foreground"
      data-testid="deal-last-changed"
    >
      {translate("resources.deals.last_changed_by", { name, date })}
    </p>
  );
};
